module.exports = __webpack_public_path__ + "media/components/country-flag/static/tw-445b56fca467f5495a0c509d5d79f18a.svg";